import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'reactstrap';
import queryString from 'query-string';
import ConfirmDialog from 'components/Dialogs/ConfirmDialog';
import { getDistrict, saveDistrict, updateDistrict, getCountryOption, deleteDistrict } from 'store/actions/location';
import List from './list';
import AddDialog from './addDialog';
import { useHistory } from 'react-router';
import { t } from 'i18next';
import AddNewButton from 'components/ActionButtons/addNewButton';

function District() {
  const [modalOpen, setModalOpen] = React.useState(false);
  const [editData, setEditData] = React.useState(null);
  const [showDelete, setShowDelete] = React.useState(false);

  const dispatch = useDispatch();
  const router = useHistory();
  const districts = useSelector((state) => state.location.districts);
  const countries = useSelector((state) => state.location.countries);

  const headers = ['no', 'name', 'region', 'created_at', 'created_by', ''];
  React.useEffect(() => {
    dispatch(getCountryOption());
    dispatch(getDistrict(queryString.parse(router.location.search), true));
  }, [getCountryOption, dispatch, router.location.search]);

  return (
    <>
      <List
        headers={headers}
        data={districts}
        onEdit={(data) => {
          setModalOpen(true);
          setEditData(data);
        }}
        onDelete={(data) => {
          setShowDelete(true);
          setEditData(data);
        }}
        buttons={
          <>
            <AddNewButton
              type='country'
              onClick={() => {
                setModalOpen(true);
                setEditData(null);
              }}
            />
            <Button style={{ width: 95 }} size='sm' onClick={() => dispatch(getDistrict({}, true))}>
              <i className='fa fa-spinner mr-2' /> {t('refresh')}
            </Button>
          </>
        }
        title={t('district')}
      />
      <AddDialog
        title={editData ? `${t('edit')} ${t('district')}` : `${t('add')} ${t('district')}`}
        editData={editData}
        modalOpen={modalOpen}
        onToggle={(open) => setModalOpen(open)}
        options={{ countries: countries }}
        onSubmit={(values) => {
          setEditData(null);
          setModalOpen(false);
          if (editData) {
            if (typeof editData.region === 'object') {
              editData.region = editData.region._id;
            }
            dispatch(updateDistrict({ ...values, _id: editData?._id }));
          } else dispatch(saveDistrict(values));
          setTimeout(() => dispatch(getDistrict({}, true)), 1000);
        }}
      />
      <ConfirmDialog
        modalOpen={showDelete}
        title={`${t('delete')} ${t('district')}`}
        body={`Are you sure to delete ${editData?.name}?`}
        onToggle={() => setShowDelete(false)}
        onConfirm={() => {
          setShowDelete(false);
          dispatch(deleteDistrict(editData?._id));
          setTimeout(() => dispatch(getDistrict({}, true)), 1000);
        }}
      />
    </>
  );
}

export default District;
